import type {Components, Theme} from '@mui/material/styles';
import {COLORS} from "~/style/colors-ts";

export const menuOverrides: Components<Theme>['MuiMenu'] = {
    styleOverrides: {
        paper: ({theme}) => ({
            boxShadow: theme.shadows[4],
            backgroundColor: COLORS.white[700],
        }),
    },
};
